export enum LEADS_SNOOZED_STORAGE_KEYS {
  LocationPreference = "leads-snoozed-location-preference",
  DealerPreference = "leads-snoozed-dealer-preference",
  DepartmentPreference = "leads-snoozed-department-preference",
  TagsPreference = "leads-snoozed-tags-preference",
  CustomerApprovedPreference = "leads-snoozed-customer-approved-preference",
  InterventionsPreference = "leads-snoozed-interventions-preference",
  AppointmentDatePreference = "leads-snoozed-appointment-date-preference",
  RegVinPreference = "leads-snoozed-reg-vin-preference",
  SnoozeDatePreference = "leads-snoozed-snooze-date-preference",
  UpdatedOnDatePreference = "leads-snoozed-updated-on-date-preference",
  SnoozeStatusPreference = "leads-snoozed-snooze-status-preference",
  TaskPreference = "leads-snoozed-task-preference",
  CustomerOkUserPreference = "leads-snoozed-customer-ok-user-preference",
  InterventionQuestionResultPreference = "leads-snoozed-intervention-question-result-preference",
  QuestionStatusPreference = "leads-snoozed-question-status-preference",
  PageSizePreference = "leads-snoozed-page-size-preference"
}

export enum LEADS_NOT_SNOOZED_STORAGE_KEYS {
  LocationPreference = "leads-not-snoozed-location-preference",
  DealerPreference = "leads-not-snoozed-dealer-preference",
  TagsPreference = "leads-not-snoozed-tags-preference",
  CustomerApprovedPreference = "leads-not-snoozed-customer-approved-preference",
  InterventionsPreference = "leads-not-snoozed-interventions-preference",
  AppointmentDatePreference = "leads-not-snoozed-appointment-date-preference",
  RegVinPreference = "leads-not-snoozed-reg-vin-preference",
  InterventionQuestionResultPreference = "leads-not-snoozed-intervention-question-result-preference",
  QuestionStatusPreference = "leads-not-snoozed-question-status-preference",
  PageSizePreference = "leads-not-snoozed-page-size-preference"
}

export enum LEADS_CARS_STORAGE_KEYS {
  LocationPreference = "leads-cars-location-preference",
  DealerPreference = "leads-cars-dealer-preference",
  DateFromPreference = "leads-cars-date-from-preference",
  DateToPreference = "leads-cars-date-to-preference",
  LeaseCompanyPreference = "leads-cars-lease-company-preference",
  PageSizePreference = "leads-cars-page-size-preference"
}
